var _circle, _mask, _g, _path, _circle2, _path2, _path3, _path4, _rect, _circle3, _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#ECFDF5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2729 118.193C100.773 117.395 104.257 119.586 105.055 123.086C107.834 135.284 115.804 140.575 124.892 146.044C125.215 146.238 125.542 146.434 125.874 146.632C129.962 149.082 134.698 151.919 138.239 155.601C142.468 159.996 145.121 165.655 144.635 173.22C144.156 180.691 140.201 186.253 134.999 190.13C129.961 193.884 123.584 196.223 117.323 197.721C104.766 200.726 90.661 200.813 82.8377 200.332C79.2546 200.111 76.5287 197.028 76.7492 193.445C76.9697 189.862 80.0531 187.136 83.6362 187.356C90.7801 187.796 103.469 187.67 114.297 185.078C119.727 183.778 124.189 181.973 127.232 179.705C130.111 177.56 131.48 175.223 131.662 172.387C131.891 168.824 130.829 166.65 128.87 164.613C126.574 162.226 123.259 160.232 118.581 157.418C118.451 157.34 118.321 157.262 118.19 157.183C108.921 151.606 96.4615 143.888 92.3795 125.974C91.582 122.474 93.7728 118.99 97.2729 118.193Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5072 203.183L35.1425 207.021C35.1425 207.021 18.1801 188.275 19.6546 165.146C21.5573 135.3 34.515 71.7294 34.515 71.7294L72.8013 69.0261C72.8013 69.0261 86.8262 115.516 95.7437 156.628C101.36 182.522 89.5072 203.183 89.5072 203.183Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8057 77.9357L70.7876 75.1833C70.7876 75.1833 82.2938 86.8231 83.4487 103.179C84.0915 112.283 81.7218 125.614 79.4943 135.644L72.9565 195.487C76.3062 201.495 75.8069 202.494 73.6943 205.936L63.6662 206.645C61.2424 203.576 60.293 202.049 63.9843 195.237C63.8798 191.543 63.7826 188.03 63.6895 184.668C63.373 173.24 63.1049 163.56 62.7685 154.449C61.0879 154.872 59.4347 155.182 57.9378 155.287C56.4518 155.392 54.7772 155.321 53.0545 155.141L57.3074 195.745C61.641 200.668 60.837 202.936 59.5942 206.44C59.5336 206.611 59.472 206.785 59.4099 206.962L50.562 207.587C50.3416 207.405 50.1308 207.235 49.9302 207.074C47.3831 205.024 46.4769 204.294 48.4853 197.399C47.6017 193.811 46.7634 190.398 45.9612 187.132C41.5752 169.276 38.2681 155.812 34.5279 142.052C30.2066 131.895 24.2377 116.47 23.5977 107.405C22.8978 97.4921 31.8057 77.9357 31.8057 77.9357Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0702 36.088C86.7009 34.9984 67.4282 47.5314 67.4282 47.5314C64.5006 46.3493 61.5252 45.4408 58.7732 45.1033C54.3222 44.5574 49.0756 45.3359 44.1419 46.5754C44.1419 46.5754 26.7816 33.5231 24.743 34.8785C22.7044 36.2339 27.031 54.389 27.031 54.389L27.5085 76.3418C30.3111 87.8548 54.0648 96.982 54.0648 96.982C54.0648 96.982 77.9351 92.1697 82.3232 81.7599L84.9634 59.5965C84.9634 59.5965 91.4395 37.1777 89.0702 36.088Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5824 72.895C50.0694 75.6131 47.3789 73.2898 44.6608 73.7767C41.9427 74.2637 40.2262 77.3767 39.7392 74.6585C39.2522 71.9404 41.3254 70.8186 44.0436 70.3316C46.7617 69.8446 49.0954 70.1768 49.5824 72.895Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9821 76.3653C70.1707 79.0048 68.8424 75.7075 66.2029 74.896C63.5634 74.0845 60.6122 76.0662 61.4237 73.4267C62.2351 70.7872 64.5919 70.7391 67.2314 71.5506C69.8709 72.362 71.7936 73.7258 70.9821 76.3653Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9803 85.03C55.3777 85.5408 56.1484 85.5453 56.5517 85.0391L59.5904 81.2248C60.1106 80.5719 59.6489 79.6066 58.814 79.6018L52.7808 79.567C51.9459 79.5621 51.4731 80.522 51.9858 81.181L54.9803 85.03Z",
    fill: "#C5AAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1205 56.1411L62.8442 45.3487L67.4445 47.2672L62.1205 56.1411Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.012 55.6129L43.7745 46.1488L48.6807 45.2697L49.012 55.6129Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3214 67.728L61.1386 45.773C61.1386 45.773 58.0645 44.7878 55.8642 44.6861C53.6639 44.5844 49.8701 45.2521 49.8701 45.2521L55.3214 67.728Z",
    fill: "#676767"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0376 23.0001L66.9677 49.0497C58.27 51.6661 53.2663 51.6527 44.9678 48.9906L56.0376 23.0001Z",
    fill: "#6366F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 23.5,
    r: 3.5,
    fill: "#A5B4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42C54 44.6667 58 44.6667 64 42",
    stroke: "#A5B4FC",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35C54.75 36.3333 57.25 36.3333 61 35",
    stroke: "#A5B4FC",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2087 90.1848L72.9688 102.569C73.2872 104.601 72.9243 105.136 70.8525 105.262L55.0924 92.878L57.2087 90.1848Z",
    fill: "#A5B4FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.0372,
    y: 87.4166,
    width: 10.7923,
    height: 3.98484,
    transform: "rotate(37.9191 54.0372 87.4166)",
    fill: "#E4E4E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5721,
    cy: 100.947,
    r: 3.5,
    transform: "rotate(34.3187 72.5721 100.947)",
    fill: "#A5B4FC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 88,
    rx: 4,
    ry: 3,
    fill: "#8A8A8A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59,
    cy: 88,
    rx: 4,
    ry: 3,
    fill: "#8A8A8A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 96.3041,
    y1: 118.413,
    x2: 78.8362,
    y2: 192.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 55.0998,
    y1: 119.21,
    x2: 60.9628,
    y2: 205.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 51.4935,
    y1: 76.5456,
    x2: 60.6954,
    y2: 206.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 53.8587,
    y1: 42.8948,
    x2: 55.2797,
    y2: 99.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder4);
export default __webpack_public_path__ + "static/media/user-placeholder-4.bff3ffc1c3b2d7cd82e9b26c24229a44.svg";
export { ForwardRef as ReactComponent };